import { CustomerRequest } from '../request-models/customer-request.model';
import { omitUndefined } from './wire-value-utils';

/**
 * The hub request body for creating or updating a customer. Copies only the allowlisted fields and drops the
 * ones that are not set, so an update stays partial; `null` (clear the field) is kept.
 */
export function toCustomerRequest(fields: CustomerRequest): CustomerRequest {
  return omitUndefined<CustomerRequest>({
    name: fields.name,
    address: fields.address,
    city: fields.city,
    state: fields.state,
    zip: fields.zip,
    phone: fields.phone,
    email: fields.email,
    notes: fields.notes,
  });
}
